import React, { createContext } from 'react';



export const GlobalContext = createContext();


const GlobalContextProvider = (props) => {

    // const productionURL = "http://developers.exdnow.com:8080/lums/";
    const developmentURL = "http://localhost:3000/";

    const URL = developmentURL;

    return(

        <GlobalContext.Provider
            value={{ 
                URL
             }}
        >

            {props.children}

        </GlobalContext.Provider>
    )
}

export default GlobalContextProvider;